module.exports = __webpack_public_path__ + "static/3-3352cb2becc2a8fd30acb703b97fe8ec.jpg";